<template>
  <button
    class="life-story-pill"
    type="button"
    :aria-label="label || undefined"
    :class="{ 'life-story-pill--large': large }"
    :title="label || undefined"
  >
    <SlideshowIcon name="play" />
    <span>{{ text }}</span>
  </button>
</template>

<script lang="ts" setup>
  import SlideshowIcon from "./SlideshowIcon.vue";

  defineProps<{
    /** What a screen reader and the tooltip say, when the text alone isn't enough. */
    label?: string;
    large?: boolean;
    text: string;
  }>();
</script>
